import React, { useEffect, useRef } from "react";

const SnowOverlay = ({ isActive }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!isActive) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    let width = window.innerWidth;
    let height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;

    // ✅ 1. 增加雪花数量 (由 200 -> 600)
    const maxFlakes = 600;
    const flakes = [];

    // 初始化雪花
    for (let i = 0; i < maxFlakes; i++) {
      // 随机生成大小，用于模拟远近 (0.5px 到 3.5px)
      const r = Math.random() * 3 + 0.5;

      flakes.push({
        x: Math.random() * width,
        y: Math.random() * height,
        r: r,
        // ✅ 2. 速度与大小挂钩：大的落得快，小的落得慢 (模拟物理惯性和空气阻力)
        d: r * 0.5,
        // ✅ 3. 透明度调低：范围 0.1 - 0.4 (之前是 0.6)，更加朦胧
        a: Math.random() * 0.2 + 0.1,
        // 增加一个随机相位，让左右摇摆不同步
        swayOffset: Math.random() * Math.PI * 2,
      });
    }

    let animationFrameId;
    let angle = 0;

    const draw = () => {
      ctx.clearRect(0, 0, width, height);

      angle += 0.01; // 全局风向变化参数

      for (let i = 0; i < maxFlakes; i++) {
        const f = flakes[i];

        // 每一片雪花都有自己的透明度
        ctx.fillStyle = `rgba(255, 255, 255, ${f.a})`;
        ctx.beginPath();
        ctx.moveTo(f.x, f.y);
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2, true);
        ctx.fill();

        // 更新位置
        // 下落速度
        f.y += f.d;

        // 左右摇摆：sin函数 + 自身偏移量，避免所有雪花整齐划一地摇摆
        // 较小的雪花受风影响更大 (系数更大)
        f.x += Math.sin(angle + f.swayOffset) * (1 - f.r / 5);

        // 边界检测：回到顶部
        if (f.y > height) {
          flakes[i] = {
            x: Math.random() * width,
            y: -10, // 从屏幕上方一点点出现
            r: f.r,
            d: f.d,
            a: f.a,
            swayOffset: f.swayOffset,
          };
        }
        // 左右边界循环
        if (f.x > width + 5) f.x = -5;
        if (f.x < -5) f.x = width + 5;
      }

      animationFrameId = requestAnimationFrame(draw);
    };

    draw();

    const handleResize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      cancelAnimationFrame(animationFrameId);
    };
  }, [isActive]);

  if (!isActive) return null;

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none z-[9999]"
      style={{ width: "100vw", height: "100vh" }}
    />
  );
};

export default SnowOverlay;
